export const JWT = 'jwt'
export const SCOPE_PREVIEW = 'scopePreview'
